module.exports = __webpack_public_path__ + "static/media/local-prod-parity.45759713.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustrations/local-prod-parity.svg
// module id = 111
// module chunks = 0